/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

import logoUrl from "url:../resources/images/dexter_logo.png";
import logoColorblindLightUrl from "url:../resources/images/dexter_logo_colorblind_light.png";
import logoColorblindDarkUrl from "url:../resources/images/dexter_logo_colorblind_dark.png";

export const LOGO_URL = new URL(logoUrl, import.meta.url);
export const LOGO_URL_COLORBLIND_LIGHT = new URL(
  logoColorblindLightUrl,
  import.meta.url
);
export const LOGO_URL_COLORBLIND_DARK = new URL(
  logoColorblindDarkUrl,
  import.meta.url
);
